<template>
  <div style="padding:14px 10px">
    <div class="cur_route">{{$route.name}}</div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/index' }">Dashboard</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="params.number" placeholder="Card number" clearable style="width:140px;">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.name" placeholder="Card name" clearable style="width:140px;">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.sms_user_name" placeholder="App user" clearable style="width:140px;">
        </el-input>
      </el-form-item>
      <el-select size="small" v-model="params.country" clearable placeholder="Country"
        style="width:140px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in countryList" :key="item.name" :label="item.name" :value="item.name">
        </el-option>
      </el-select>
      <!-- <el-select size="small" v-model="params.operator_id" clearable placeholder="Operator"
        style="width:140px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in operatorList" :key="item.id" :label="item.name+'【'+item.country+'】'" :value="item.id">
        </el-option>
      </el-select> -->
      <!-- <el-select size="small" v-model="editForm.operator_id" clearable placeholder="Select Operator">
            <el-option v-for="item in operatorList" :key="item.id" :label="item.name+'【'+item.country+'】'"
              :value="item.id">
            </el-option>
          </el-select> -->
      <el-cascader :options="operatorList" size="small"
        :props="{ checkStrictly: true,value:'id',label:'name',expandTrigger: 'hover'}" clearable
        placeholder="Select Operator" @change="operatorParamsChange" style="position:relative;top: 5px;right:5px">
      </el-cascader>
      <el-select size="small" v-model="params.opencard_id" clearable placeholder="Cardholder"
        style="width:140px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in opencardList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.card_sort" clearable placeholder="Sort"
        style="width:140px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in card_sort_list" :key="item.k" :label="item.v" :value="item.v">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.card_type" clearable placeholder="Card Type"
        style="width:140px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in card_type_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button type="success" size="small" icon="el-icon-document" @click="exportExcel">Export</el-button>
        <el-button size="small" type="warning" icon="el-icon-plus" @click="handleEdit()">Add</el-button>
        <el-button size="small" type="danger" icon="el-icon-delete" :disabled="selectedCards.length === 0"
          @click="handleBatchDelete">Batch Delete ({{selectedCards.length}})</el-button>
        <el-button size="small" type="danger" @click="setBalanceReminder()">Set balance
          reminder</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="Loading..."
      style="width: 1642px;" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column prop="id" label="ID" width="60" align="center">
      </el-table-column>
      <el-table-column prop="number" label="Card number" width="110">
        <template slot-scope="scope">
          <div>{{scope.row.number}}</div>
          <div>{{scope.row.name}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="operator_name" label="Operator" width="140">
        <template slot-scope="scope">
          <div>{{scope.row.operator_name}}</div>
          <div>{{scope.row.card_type|cardtype}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="business_name" label="Business" width="100">
      </el-table-column>
      <el-table-column prop="single_min" label="Single" width="120">
        <template slot-scope="scope">
          <div><span style="color:#909399">min：</span>{{scope.row.single_min}}</div>
          <div><span style="color:#909399">max：</span>{{scope.row.single_max}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="day_limit" label="Day limit" width="90">
      </el-table-column>
      <el-table-column prop="balance_max" label="Balance max" width="100">
      </el-table-column>
      <el-table-column prop="balance_reminder" label="Balance reminder" width="100">
      </el-table-column>
      
      <el-table-column prop="state" label="Status" width="90" align="center" sortable>
        <template slot-scope="scope">
          <el-link type="info" icon="el-icon-edit" @click="changeState(scope.row.id,scope.row.number,2)"
            :underline="false" v-if="scope.row.state==1">using</el-link>
          <el-link type="danger" icon="el-icon-edit" @click="changeState(scope.row.id,scope.row.number,1)"
            :underline="false" v-if="scope.row.state==2">disabled</el-link>
        </template>
      </el-table-column>

      <el-table-column prop="opencard_name" label="Cardholder" width="140" align="center">
        <template slot-scope="scope">
          <div><span style="color:#909399">Cardholder：</span>{{scope.row.opencard_name}}</div>
          <div><span style="color:#909399">Receive：</span>
            <el-link type="info" :underline="false" v-if="scope.row.is_receive==1">YES</el-link>
            <el-link type="danger" :underline="false" v-if="scope.row.is_receive==2">NO</el-link>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="sms_user_name" label="APP user" width="100">
        <template slot-scope="scope">
          <el-link type="success" icon="el-icon-edit" :underline="false" v-if="scope.row.sms_user_name"
            @click="setCard(scope.row)">{{scope.row.sms_user_name}}</el-link>
          <el-link type="primary" icon="el-icon-edit" :underline="false" v-else @click="setCard(scope.row)">Set up
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="pin" label="Payment pin" width="120">
        <template slot-scope="scope">
          <div><span style="color:#909399">pin：</span>{{scope.row.pin}}</div>
          <div><span style="color:#909399">AGENT：</span>{{scope.row.agent_id}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="save_time" label="Save time" width="140">
        <template slot-scope="scope">
          <div>{{scope.row.save_time|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column label="Action" width="160" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="warning" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- Edit界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click='closeDialog("edit")'>
      <el-form label-width="180px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="Card number" prop="number">
          <el-input size="small" v-model="editForm.number" type="number" auto-complete="off"
            placeholdern="9-digit mobile phone number without 0/254 in front" clearable style="width:60%">
          </el-input>
        </el-form-item>
        <el-form-item label="Card name" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="SIM card name" clearable
            style="width:60%">
          </el-input>
        </el-form-item>
        <el-form-item label="Operator" prop="operator_id">
          <!-- <el-select size="small" v-model="editForm.operator_id" clearable placeholder="Select Operator">
            <el-option v-for="item in operatorList" :key="item.id" :label="item.name+'【'+item.country+'】'"
              :value="item.id">
            </el-option>
          </el-select> -->
          <el-cascader :options="operatorList" size="small"
            :props="{ checkStrictly: true,value:'id',label:'name',expandTrigger: 'hover'}" clearable
            placeholder="Select Operator" @change="operatorChange" style="position:relative;right:2px">
          </el-cascader>
        </el-form-item>
        <el-form-item label="Cardholder" prop="opencard_id">
          <el-select size="small" v-model="editForm.opencard_id" clearable placeholder="Select Cardholder">
            <el-option v-for="item in opencardList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Card Type" prop="card_type">
          <el-radio-group v-model="editForm.card_type">
            <el-radio :label="1">Agent line</el-radio>
            <el-radio :label="2">Personal line</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Single minimum payment" prop="single_min">
          <el-input size="small" v-model="editForm.single_min" auto-complete="off"
            placeholder="Single minimum payment (leave blank if not set)" clearable style="width:60%">
          </el-input>
        </el-form-item>
        <el-form-item label="Single maximum payment" prop="single_max">
          <el-input size="small" v-model="editForm.single_max" auto-complete="off"
            placeholder="Single maximum payment (leave blank if not set)" clearable style="width:60%">
          </el-input>
        </el-form-item>
        <el-form-item label="Daily payment limit" prop="day_limit">
          <el-input size="small" v-model="editForm.day_limit" auto-complete="off"
            placeholder="Daily payment limit (leave blank if not set)" clearable style="width:60%">
          </el-input>
        </el-form-item>
        <el-form-item label="Maximum balance" prop="balance_max">
          <el-input size="small" v-model="editForm.balance_max" auto-complete="off"
            placeholder="Maximum balance (leave blank if not set)" clearable style="width:60%">
          </el-input>
        </el-form-item>
        <el-form-item label="Balance reminder" prop="balance_reminder">
          <el-input size="small" v-model="editForm.balance_reminder" auto-complete="off"
            placeholder="Balance reminder (leave blank if not set)" clearable style="width:60%">
          </el-input>
        </el-form-item>
        <el-form-item label="Payment PIN" prop="pin">
          <el-input size="small" v-model="editForm.pin" auto-complete="off" placeholder="Payment PIN" clearable
            style="width:60%">
          </el-input>
        </el-form-item>
        <el-form-item label="AGENT ID" prop="agent_id">
          <el-input size="small" v-model="editForm.agent_id" auto-complete="off" placeholder="AGENT ID" clearable
            style="width:60%">
          </el-input>
        </el-form-item>
        <el-form-item label="Status" prop="state">
          <el-radio-group v-model="editForm.state">
            <el-radio :label="1">using</el-radio>
            <el-radio :label="2">disabled</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Receive sms" prop="is_receive">
          <el-radio-group v-model="editForm.is_receive">
            <el-radio :label="1">YES</el-radio>
            <el-radio :label="2">NO</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">Save
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="APP User" :visible.sync="smsUserVisible" width="65%" @click='closeDialog("sms_user")'>
      <el-table size="small" :data="sms_user_list" highlight-current-row v-loading="loading"
        element-loading-text="Loading..." style="width:581px">
        <el-table-column prop="sms_user_id" label="Check" width="80">
          <template slot-scope="scope">
            <el-radio v-model="editSmsUser.sms_user_id" :label="scope.row.id"></el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Name" width="100">
        </el-table-column>
        <el-table-column prop="country" label="Country" width="100">
        </el-table-column>
        <el-table-column prop="socket_id" label="Online/Offline" width="120" align="center">
          <template slot-scope="scope">
            <el-link type="danger" :underline="false" v-if="scope.row.socket_id==0">Offline</el-link>
            <el-link type="info" :underline="false" v-else>Online</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="auto_trans" label="Automatic Withdraw" width="180" align="center">
          <template slot-scope="scope">
            <el-link type="info" :underline="false" v-if="scope.row.auto_trans==1">Yes</el-link>
            <el-link type="danger" :underline="false" v-else>No</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("sms_user")'>Cancel</el-button>
        <el-button size="small" type="danger" :loading="loading" class="title" @click="resetCard">Reset
        </el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitCard">Save
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="Set balance reminder" :visible.sync="balanceReminderFormVisible" width="40%"
      @click='closeDialog("balanceReminderForm")'>
      <el-form label-width="180px" :model="balanceReminderForm" ref="balanceReminderForm">
        <el-form-item label="Country" prop="country">
          <el-select size="small" v-model="balanceReminderForm.country" clearable placeholder="Country"
            style="width:180px;">
            <el-option v-for="item in countryList" :key="item.name" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Balance reminder" prop="name">
          <el-input type="number" size="small" v-model="balanceReminderForm.balance_reminder" auto-complete="off"
            placeholder="Balance reminder" clearable style="width:60%">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("balanceReminderForm")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="balanceReminderSave">Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  let that = ""
  import {
    cardList,
    cardSave,
    cardDel,
    cardBatchDel,
    updateCardState,
    cardSmsUserList,
    smsAppSet,
    smsAppReset,
    cardAttachList,
    cardBalanceReminderSave,
  } from '../../api/apiFun'
  import {
    timestampToTime,
    uploadUrl,
    getCookie,
    exportUrl,
    cascaderChange,
  } from '@/utils/util';
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        countryList: [],
        operatorList: [],
        opencardList: [],
        loading: false, //是显示加载
        editFormVisible: false, //控制Edit页面显示与隐藏
        title: 'Add',
        params: {
          page: 1,
          limit: 10,
          number: '',
          name: '',
          sms_user_name: '',
          operator_id: '',
          opencard_id: '',
          card_sort: '',
          country: '',
          card_type: ''
        },
        card_sort_list: [{
          k: 1,
          v: 'single_min'
        },
        {
          k: 2,
          v: 'single_max'
        },
        {
          k: 3,
          v: 'day_limit'
        },
        {
          k: 4,
          v: 'balance_max'
        },
        ],
        listData: [], //SIM card数据
        selectedCards: [],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        editForm: {
          id: '',
          number: '',
          pin: '',
          agent_id: '',
          is_receive: 1,
          operator_id: '',
          opencard_id: '',
          single_min: '',
          single_max: '',
          day_limit: '',
          balance_max: '',
          balance_reminder: '',
          name: '',
          state: 1,
          card_type: 1
        },
        // rules 表单验证
        rules: {
          number: [{
            required: true,
            message: 'Please enter the SIM card number',
            trigger: 'blur'
          }],
          name: [{
            required: true,
            message: 'Please enter the SIM card name',
            trigger: 'blur'
          }],
          state: [{
            required: true,
            message: 'Please select state',
            trigger: 'blur'
          }],
          card_type: [{
            required: true,
            message: 'Please select card_type',
            trigger: 'blur'
          }],
          country: [{
            required: true,
            message: 'Please select country',
            trigger: 'blur'
          }],
          operator_id: [{
            required: true,
            message: 'Please select operator',
            trigger: 'blur'
          }],
          opencard_id: [{
            required: true,
            message: 'Please select cardholder',
            trigger: 'blur'
          }],
        },
        smsUserVisible: false,
        editSmsUser: {
          id: '',
          sms_user_id: '',
        },
        sms_user_list: [],
        upload_url: uploadUrl(),
        upload_header: {
          Authorization: getCookie('dkh_token')
        },
        dialogImageUrl: '',
        dialogQrcodeVisible: false,
        card_type_list: [{
          k: 1,
          v: 'Agent line'
        },
        {
          k: 2,
          v: 'Personal line'
        }
        ],
        balanceReminderFormVisible: false, //控制Edit页面显示与隐藏
        balanceReminderForm: {
          country: '',
          balance_reminder: ''
        },
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    filters: {
      timestampToTime: function (timestamp) {
        return timestampToTime(timestamp)
      },
      cardtype: function (i) {
        var v = '';
        that.card_type_list.forEach(e => {
          if (e.k == i) {
            v = e.v
          }
        });
        return v
      },
    },
    created() {
      that = this
      this.getdata(this.params)
      this.cardAttachList()
    },
    methods: {
      handleSelectionChange(selection) {
        this.selectedCards = selection
      },
      handleBatchDelete() {
        if (!this.selectedCards.length) {
          this.$message.warning('Please select the cards to delete')
          return
        }

        const selectedIds = this.selectedCards.map(item => item.id)
        const selectedCount = selectedIds.length
        this.$confirm(
          'Are you sure you want to permanently delete the selected ' + selectedCount + ' cards?',
          'Batch Delete',
          {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
        ).then(() => {
          this.loading = true
          cardBatchDel({
            ids: selectedIds.join(',')
          }).then(res => {
            this.loading = false
            if (res.code == 200) {
              if (selectedCount >= this.listData.length && this.params.page > 1) {
                this.params.page--
              }
              this.selectedCards = []
              this.$message({
                type: 'success',
                message: res.datas.count + ' cards deleted successfully!'
              })
              this.getdata(this.params)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.loading = false
            this.$message.error('Batch deletion failed, please try again later!')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Batch deletion cancelled'
          })
        })
      },
      handleDelete(index, row) {
        this.$confirm('Are you sure you want to delete?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          cardDel({
            id: row.id,
            number: row.number,
            business_id: row.business_id,
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'successfully deleted!'
              })
              this.getdata(this.params)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.$message.error('Deletion failed, please try again later!')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Undelete'
          })
        })
      },
      balanceReminderSave() {
        if (!this.balanceReminderForm.country) {
          this.$message.error('请选择国家')
          return
        }
        if (!this.balanceReminderForm.balance_reminder) {
          this.$message.error('请填写余额提醒值')
          return
        }
        this.$confirm('确定要设置余额提醒值吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          cardBalanceReminderSave(this.balanceReminderForm).then(res => {
            this.loading = false
            this.balanceReminderFormVisible = false
            if (res.code == 200) {
              this.getdata(this.params)
              this.$message({
                type: 'success',
                message: '完成设置余额提醒值！'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.loading = false
            this.balanceReminderFormVisible = false
            this.$message.error('设置余额提醒值失败，请稍后再试！')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消设置余额提醒值'
          });
        });
      },
      setBalanceReminder() {
        this.balanceReminderFormVisible = true
        this.balanceReminderForm = {
          country: '',
          balance_reminder: ''
        }
      },
      operatorParamsChange(value) {
        var cascader = cascaderChange(value)
        this.params.operator_id = cascader[1]
      },
      operatorChange(value) {
        var cascader = cascaderChange(value)
        this.editForm.operator_id = cascader[1]
      },
      exportExcel() {
        window.location.href = exportUrl('/admin/card/export_card', this.params);
      },
      cardAttachList() {
        cardAttachList().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.countryList = res.datas.country_list
            this.operatorList = res.datas.operator_list
            this.opencardList = res.datas.opencard_list
          }
        }).catch(err => {
          this.$message.error('Failed to get Operator information, please try again later!')
        })
      },
      resetCard() {
        this.loading = true
        smsAppReset(this.editSmsUser).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.getdata(this.params)
            this.$message({
              type: 'success',
              message: 'Reset successed'
            })
            this.smsUserVisible = false

          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Reset failed, please try again later!')
        })
      },
      submitCard() {
        this.loading = true
        smsAppSet(this.editSmsUser).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.getdata(this.params)
            this.$message({
              type: 'success',
              message: 'Edit succeeded'
            })
            this.smsUserVisible = false

          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Edit failed, please try again later!')
        })
      },
      setCard(row) {
        this.editSmsUser.id = row.id
        this.cardSmsUserList({
          sms_user_id: row.sms_user_id,
          operator_id: row.operator_id
        })
        this.editSmsUser.sms_user_id = row.sms_user_id
        this.smsUserVisible = true
      },
      cardSmsUserList(params) {
        cardSmsUserList(params).then(res => {
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.sms_user_list = res.datas.list
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get SIM card list, please try again later!')
        })
      },
      // EditSIM cardStatus
      changeState(id, number, state) {
        var t = 'Confirm to modify the' + number + ' status code of the mobile phone card?'
        this.$confirm(t, 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          var parameter = {
            id,
            state
          }
          this.loading = true
          updateCardState(parameter).then(res => {
            this.loading = false
            if (res.code == 400) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: 'Edit succeeded'
              })
              this.getdata(this.params)
            }
          }).catch(err => {
            this.loading = false
            this.$message.error('Edit failed, please try again later!')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancel edit'
          });
        });
      },
      //显示Edit界面
      handleEdit: function (index, row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = 'Edit'
          this.editForm.id = row.id
          this.editForm.number = row.number
          this.editForm.pin = row.pin
          this.editForm.agent_id = row.agent_id
          this.editForm.is_receive = row.is_receive
          this.editForm.operator_id = row.operator_id
          this.editForm.opencard_id = row.opencard_id
          this.editForm.name = row.name
          this.editForm.state = row.state
          this.editForm.card_type = row.card_type
          this.editForm.single_min = row.single_min || ''
          this.editForm.single_max = row.single_max || ''
          this.editForm.day_limit = row.day_limit || ''
          this.editForm.balance_max = row.balance_max || ''
          this.editForm.balance_reminder = row.balance_reminder || ''
        } else {
          this.title = 'Add'
          this.editForm.id = ''
          this.editForm.number = ''
          this.editForm.pin = ''
          this.editForm.agent_id = ''
          this.editForm.is_receive = 1
          this.editForm.operator_id = ''
          this.editForm.opencard_id = ''
          this.editForm.name = ''
          this.editForm.state = 1
          this.editForm.card_type = 1
          this.editForm.single_min = ''
          this.editForm.single_max = ''
          this.editForm.day_limit = ''
          this.editForm.balance_max = ''
          this.editForm.balance_reminder = ''
        }
      },
      // Edit、增加页面Save方法
      submitForm(editData) {
        this.loading = true
        this.$refs[editData].validate(valid => {
          if (valid) {
            cardSave(this.editForm).then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.getdata(this.params)
                this.$message({
                  type: 'success',
                  message: 'SIM card save successed！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            }).catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('SIM card save failed, please try again later!')
            })
          } else {
            return false
          }
        })
      },
      // 获取Card list
      getdata(parameter) {
        this.loading = true
        cardList(parameter).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.datas.list
            // 分页赋值
            this.pageparm.currentPage = this.params.page
            this.pageparm.pageSize = this.params.limit
            this.pageparm.total = res.datas.count
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get card list, please try again later!')
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.params.page = parm.currentPage
        this.params.limit = parm.pageSize
        this.getdata(this.params)
      },
      // Search事件
      search() {
        this.params.page = 1
        this.getdata(this.params)
      },
      // closeEdit、增加弹出框
      closeDialog(dialog) {
        if (dialog == 'edit') {
          this.editFormVisible = false
        }
        if (dialog == 'sms_user') {
          this.smsUserVisible = false
        }
        if (dialog == 'balanceReminderForm') {
          this.balanceReminderFormVisible = false
        }
      },
    }
  }

</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/card/card_list.vue